module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Header/images/victory-background.44bb1d94.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Header/images/victory-background.jpg
// module id = 3236
// module chunks = 11